import {AxiosResponse} from 'axios';

import tokenInstance from 'utils/axiosInstance/tokenInstance';

const getPreferences = (): Promise<AxiosResponse<any, any>> => {
    return tokenInstance().get(`/hope-and-expectation/settings`);
};

type HopeMessageType = 'positive-message' | 'focus-encouragement' | 'motivation-boost' | 'feature-tip' | 'productivity-suggestion';
const getRandomHopeMessage = (messageType: HopeMessageType): Promise<AxiosResponse<any, any>> => {
    return tokenInstance().get(`/hope-and-expectation/${messageType}/random`);
};
const patchPreferences = ({
        frequency,
        positive_message_enabled,
        focus_encouragement_enabled,
        motivation_boost_enabled,
        feature_tip_enabled,
        productivity_suggestion_enabled
}: {
        frequency: number,
        positive_message_enabled: boolean;
        focus_encouragement_enabled: boolean;
        motivation_boost_enabled: boolean;
        feature_tip_enabled: boolean;
        productivity_suggestion_enabled: boolean;
}): Promise<AxiosResponse<any, any>> => {
    return tokenInstance().patch(`/hope-and-expectation/settings`, {
        frequency,
        positive_message_enabled,
        focus_encouragement_enabled,
        motivation_boost_enabled,
        feature_tip_enabled,
        productivity_suggestion_enabled,
    });
};
const giveThumbsUp = (deliveryId: number): Promise<AxiosResponse<any, any>> => {
    return tokenInstance().get(`/hope-and-expectation/deliveries/${deliveryId}/thumbs-up`);
};
const giveThumbsDown = (deliveryId: number): Promise<AxiosResponse<any, any>> => {
    return tokenInstance().get(`/hope-and-expectation/deliveries/${deliveryId}/thumbs-down`);
};

export const HopeAndExpectationService = {
    getRandomHopeMessage,
    getPreferences,
    patchPreferences,
    giveThumbsUp,
    giveThumbsDown
};
